import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
  providedIn: 'root',
})
export class Tourservice {
  private platformId = inject(PLATFORM_ID);
  isOpen = signal(false); 
  currentIndex = signal(0);
  steps = signal<any[]>([]);
  styles = signal({ high: {}, box: {} });
  isTourEnabled = signal(true);


  registerSteps(newSteps: any[]) {
    if (!this.isTourEnabled()) return;

    this.steps.set(newSteps);
    console.log("Steps registered:", this.steps());

    if (this.steps().length > 0) {
      this.startTour();
    }
  }

  startTour() {
    if (!this.isTourEnabled()) return; // Removed localStorage check
    this.currentIndex.set(0); this.isOpen.set(true); this.update();
  }

  update() {
  if (!isPlatformBrowser(this.platformId)) return;

  setTimeout(() => {
    const currentStep = this.steps()[this.currentIndex()];
    if (!currentStep) return;

    const target = document.querySelector(currentStep.el) as HTMLElement;
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const rect = target.getBoundingClientRect();
    const [sX, sY] = [window.scrollX, window.scrollY];
    const off = 8, boxWidth = 288, boxHeight = 220, gap = 20;

    // 1. Detect if element is on the right side of the screen
    const isRightSide = (rect.left + rect.width / 2) > window.innerWidth / 2;

    // 2. Vertical Position (same as your logic)
    let topPos = rect.bottom + sY + gap;
    if (window.innerHeight - rect.bottom < boxHeight + gap) {
      topPos = rect.top + sY - boxHeight - gap;
    }

    // 3. Horizontal Position Flip Logic
    const boxStyles: any = {
      top: `${topPos}px`,
      position: 'absolute'
    };

    if (isRightSide) {
      boxStyles.left = 'auto';
      // Calculate right based on the distance from the right edge of the screen
      boxStyles.right = `${window.innerWidth - (rect.right + sX)}px`;
    } else {
      boxStyles.right = 'auto';
      boxStyles.left = `${rect.left + sX}px`;
    }

    this.styles.set({
      high: {
        top: `${rect.top + sY - off}px`,
        left: `${rect.left + sX - off}px`,
        width: `${rect.width + off * 2}px`,
        height: `${rect.height + off * 2}px`,
        position: 'absolute'
      },
      box: boxStyles
    });
  }, 200);
}

  next() {
    this.currentIndex() < this.steps().length - 1 ? (this.currentIndex.update(v => v + 1), this.update()) : this.close();
  }

  back() {
    if (this.currentIndex() > 0) { this.currentIndex.update(v => v - 1); this.update(); }
  }

  close() {
    this.isOpen.set(false); this.steps.set([]);
  }
}
